
const {ccclass,property} = cc._decorator;

@ccclass
export default class CardMoveCom extends cc.Component{

    @property(cc.Node)
    public targetNode : cc.Node = null;  
    
    @property(cc.Float)
    /**
     * 延迟移动 时间:秒 -1表示手动控制 
     */
    public delayMove : number = -1;

    @property(cc.Float)
    public distanceMove : number = 0;
    
    @property(cc.Float)
    public duration : number = 0.3;

    private initPos : cc.Vec3;

    start(){

        this.initPos = this.node.position;

        //cc.log(" start CardSelfCom node ",this.name);
    }

    onDisable(){

        this.reset();
    }

    reset(){

        //cc.log("  CardSelfCom  reset " , this.name);
        if (!this.initPos) {
            return;
        }
        this.node.position = this.initPos;
        
        this.node.stopAllActions();
        this.unscheduleAllCallbacks();
    }

    public onEnable(){

        this.reset();
        
        this.unschedule(this.moveTo);

        if (this.delayMove == 0) {
         
            this.move();
        }        
        else if(this.delayMove != -1){
            
            this.scheduleOnce(this.move,this.delayMove);
        }        
    }
    
    private move(){

        if (this.targetNode) {
            
            this.moveTo();
        }else{

            this.moveBy();
        }
    }

    public moveBy(time? : number, offset? : cc.Vec2,callback ? : Function){

        if (!offset) {
            
            offset = cc.v2(this.distanceMove,0);
        }


        if (time == -1) {
            //表示马上移动
            this.node.position = new cc.Vec3(this.node.position.x + offset.x , this.node.position.y + offset.y);
            if (callback) {
                callback();
            }
            return;
        }

        if (!time) {
            
            time = this.duration;
        }

        // this.action = cc.moveBy(time,offset);
        // this.action.easing(cc.easeSineIn());
        // this.node.runAction(this.action);

        let self = this;

        this.node.runAction( cc.sequence(cc.moveBy(time,offset).easing(cc.easeSineIn()),cc.callFunc( function(){
            if (callback) {
                callback();
            }
        })));
 
    }

    public moveTo(time? : number,target? : cc.Node,callback ? : Function, scaleToX? : number  , scaleToY? : number )
    {
        if (!target) {
            
            target = this.targetNode;
        }

        if(time == -1){

            //表示马上移动
            this.node.position = target.position;
            if (scaleToX) {
                this.node.scaleX = scaleToX;    
            }
            
            if (scaleToY) {
                this.node.scaleY = scaleToY;    
            }
            
            if (callback) {
                callback();
            }
            return;
        }
        if (!time) {
            
            time = this.duration;
        }

        let moveAct = cc.moveTo(time,new cc.Vec2(target.position.x,target.position.y)).easing(cc.easeSineIn());
        let scaleAct = cc.scaleTo(time,scaleToX,scaleToY);
    
        this.node.runAction( cc.sequence( cc.spawn(moveAct, scaleToX ? scaleAct : null) ,cc.callFunc(function(){
            if (callback) {
                callback();
            }
        }) ));     
        
    }


}
